<div
  class="form-control-container"
  #wrapper
  [ngStyle]="{ visibility: !attachedToShadowDom() ? 'hidden' : 'visible' }"
>
  <label class="form-control-label" for="selectId">
    {{ isRequired ? label + ' *' : label }}
  </label>

  @if(!isMultiSelect) {
  <p-select
    #select
    inputId="selectId"
    [editable]="true"
    [loading]="loading"
    [showClear]="showClear"
    [filterPlaceholder]="filterPlaceHolder"
    [options]="selectOptions"
    [filter]="filter"
    [disabled]="disabled"
    [optionValue]="optionValue"
    [optionLabel]="optionLabel"
    [optionDisabled]="optionDisabled"
    [emptyFilterMessage]="emptyFilterMessage"
    [placeholder]="'Select ' + placeholder"
    [formControl]="selectControl"
    (onShow)="isDropdownOpen = true"
    (onHide)="isDropdownOpen = false"
    (blur)="isFocused = false"
    (focus)="isFocused = true"
    (click)="select.show()"
  />
  } @else {
  <p-multiselect
    #multiSelect
    inputId="selectId"
    [loading]="loading"
    [options]="selectOptions"
    [filter]="filter"
    [showClear]="showClear"
    [filterPlaceHolder]="filterPlaceHolder"
    [disabled]="disabled"
    [optionValue]="optionValue"
    [optionLabel]="optionLabel"
    [optionDisabled]="optionDisabled"
    [emptyFilterMessage]="emptyFilterMessage"
    [placeholder]="'Select ' + placeholder"
    [selectedItemsLabel]="selectedItemsLabel"
    [formControl]="selectControl"
    (onPanelShow)="isDropdownOpen = true"
    (onPanelHide)="isDropdownOpen = false"
    (blur)="isFocused = false"
    (focus)="isFocused = true"
  ></p-multiselect>
  } @if (selectControl.invalid && selectControl.touched && !isDropdownOpen) {
  <div>
    <p class="form-control-error-message">This field is required.</p>
  </div>
  } @if (hint() && isFocused && !permanentHint()) {
  <div>
    <p class="form-control-hint-message">{{ hint() }}</p>
  </div>
  } @if (hint() && permanentHint() && !selectControl.invalid) {
  <div>
    <p class="form-control-hint-message">{{ hint() }}</p>
  </div>
  }
</div>
